/**
 * Third-party / legacy HTTP endpoints used by market watch thunks.
 * Kept out of Redux slices so URLs and transport stay in one place (testable, env-friendly later).
 */

/** Key bootstrap used by loginApiKey thunk (unchanged URL — business requirement). */
export const FXBAZZAR_LOGIN_KEY_URL =
  "https://fxbazzar.com/api/apirahul?e10adc3949ba59abbe56e057f20f883e&json=1";

export function fetchLoginKeyRawText() {
  return fetch(FXBAZZAR_LOGIN_KEY_URL).then((r) => r.text());
}

/** Live rates proxy (bbdterminal) — same contract as previous slice implementation. */
export function fetchBbdTerminalJson(key, segment, token) {
  const url = `http://bbdterminal.com/api/${key}/json2?${segment}&token=${token}`;
  return fetch(url).then((r) => r.json());
}
